import { render, staticRenderFns } from "./ReturnedRequest.vue?vue&type=template&id=646c842e&scoped=true&"
import script from "./ReturnedRequest.vue?vue&type=script&lang=js&"
export * from "./ReturnedRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c842e",
  null
  
)

export default component.exports